<app-header></app-header>

<section class="event-page inner">
  
    <!-- 이벤트페이지 -->
    <section>
            <ng-container *ngIf="eventOrderCount > 0; else notOrder">
                <section class="event-message-wrapper">
                    <p class="event-message">🎀 이미 이벤트에 참여하셨습니다 🎀</p>
                </section>   
            </ng-container>
            <ng-template #notOrder>
                <div class="goods-list inner clearfix">
                    <div class="goods-card cp" [ngClass]="{type1:viewType==2,type2:viewType==3}" *ngFor='let row of eachEventList'>
                        <a routerLink="/product/info" [queryParams]="{productSeq: row.product_seq , eventSeq: 653}" target="_blank">
                        
                        <div class="goods-img">
                            <img [src]="getImageSrc(row)" [alt]="row.product_name" (error)="onImageError(row)" />
                        </div>
                        <div class="goods-info">
                            <p class="code">상품통합코드 : {{row.product_seq}}</p>
                            <p class="pr-text" [innerHTML]="row.comment"></p>
                            <p class="name" [innerHTML]="row.product_name | safe: 'html'"></p>
                            <p class="price">
                            <ng-container *ngIf="row.is_memberDiscount == 1; else notMemberDiscount">
                                <span class="sale" *ngIf="comparePrice(row.display_price, row.consumer_price)">{{ (row.display_price - row.consumer_price) / row.display_price | percent }}</span>
                                <span>{{ row.consumer_price | number }}원</span>
                                <del *ngIf="comparePrice(row.display_price, row.consumer_price)">{{ row.display_price | number }}원</del>
                            </ng-container>
                            <ng-template #notMemberDiscount>
                                <span class="sale" *ngIf="comparePrice(row.event_price, row.consumer_price)">{{ (row.event_price - row.consumer_price) / row.event_price | percent }}</span>
                                <span>{{ row.consumer_price | number }}원</span>
                                <del *ngIf="comparePrice(row.event_price, row.consumer_price)">{{ row.event_price | number }}원</del>
                            </ng-template>
                            </p>
                            <p class="mileage">적립 <span>{{row.mileage | number}}</span> M</p>
                        </div>
                        </a>
                    </div>
                    </div>
    
            </ng-template>    
          <!-- </ng-container>
        </mat-tab>
      </mat-tab-group> -->
    </section>
  
</section>
  
  <app-footer></app-footer>